import { render } from "./carData.vue?vue&type=template&id=a34ddfc4"
import script from "./carData.vue?vue&type=script&lang=js"
export * from "./carData.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tomer\\projects\\pmaculator-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__